import React, { createContext, useContext, ReactNode } from 'react';
import { RecommendationProps } from '@/components/RecommendationCard';

interface RecommendationsContextType {
  recommendations: RecommendationProps[];
  isLoading: boolean;
  error: string | null;
  setRecommendations: (recommendations: RecommendationProps[]) => void;
  setIsLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
}

const RecommendationsContext = createContext<RecommendationsContextType | undefined>(undefined);

export const RecommendationsProvider = ({ children }: { children: ReactNode }) => {
  const [recommendations, setRecommendations] = React.useState<RecommendationProps[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const value = {
    recommendations,
    isLoading,
    error,
    setRecommendations,
    setIsLoading,
    setError,
  };

  return (
    <RecommendationsContext.Provider value={value}>
      {children}
    </RecommendationsContext.Provider>
  );
};

export const useRecommendations = () => {
  const context = useContext(RecommendationsContext);
  if (context === undefined) {
    throw new Error('useRecommendations must be used within a RecommendationsProvider');
  }
  return context;
}; 